/**
 * HTTP layer for sales orders. The order list, grid stats, and the
 * order-confirmation email trigger.
 *
 * Contains:
 * - fetchOrderSales: sales-order list
 * - fetchOrderSalesStats: order grid stats
 * - sendConfirmationEmail: send an order's confirmation email
 */
import apiClient from '@sophocles/http-common';
import { generateQueryParams } from '@sophocles/utils';

const ORDER_SALE_ENDPOINT = '/warehouse/order-sales';

export const fetchOrderSales = queryParams =>
  apiClient.get(`${ORDER_SALE_ENDPOINT}/`, { params: generateQueryParams(queryParams) }).then(res => res.data);

export const sendConfirmationEmail = orderSaleId =>
  apiClient.post(`${ORDER_SALE_ENDPOINT}/${orderSaleId}/send-confirmation/`);

// odl-app summary stats for the order-sales grid — distinct base path from the
// legacy warehouse list above.
export const fetchOrderSalesStats = params =>
  apiClient.get('odl-app/order-sales/stats/', { params }).then(res => res.data);
